export const API_ROUTES = {
  auth: {
    login: '/auth/login',
    profile: '/auth/profile',
    profilePhoneOtp: '/auth/profile/phone-otp',
    sendMfaOtp: '/auth/mfa/send-otp',
    verifyMfaOtp: '/auth/mfa/verify-otp',
    capabilities: '/auth/capabilities',
    changePassword: '/auth/change-password',
    forgotPassword: '/auth/forgot-password',
    verifyEmail: '/auth/email-verification/verify',
    verifyInvite: '/auth/invite/verify',
    acceptInvite: '/auth/invite/accept',
    verifyResetPassword: '/auth/reset-password/verify',
    resetPassword: '/auth/reset-password',
    adminPushDevice: (deviceId) => `/auth/admin-push-devices/${encodeURIComponent(deviceId)}`,
  },
  superadmin: {
    dashboard: '/superadmin/dashboard',
    societies: '/superadmin/societies',
    society: (id) => `/superadmin/societies/${encodeURIComponent(id)}`,
    adminUsers: '/superadmin/admin-users',
    adminUserStatus: (id) => `/superadmin/admin-users/${encodeURIComponent(id)}/status`,
    adminUserAccess: (id) => `/superadmin/admin-users/${encodeURIComponent(id)}/access`,
    adminUserResendInvite: (id) => `/superadmin/admin-users/${encodeURIComponent(id)}/resend-invite`,
    societyAdmins: '/superadmin/society-admins',
  },
  societyAdmin: {
    dashboard: '/society-admin/dashboard',
    managers: '/society-admin/managers',
    managerStatus: (id) => `/society-admin/managers/${encodeURIComponent(id)}/status`,
    managerAccess: (id) => `/society-admin/managers/${encodeURIComponent(id)}/access`,
    managerResendInvite: (id) => `/society-admin/managers/${encodeURIComponent(id)}/resend-invite`,
    roles: '/society-admin/roles',
    role: (id) => `/society-admin/roles/${encodeURIComponent(id)}`,
    roleAvailablePermissions: '/society-admin/roles/available-permissions',
  },
  settings: {
    preferences: '/settings/me/preferences',
    notifications: '/settings/me/notifications',
    societyOperations: '/settings/society-operations',
    societyGuardPolicy: '/settings/society-guard-policy',
    supportTicketDigest: '/settings/support-ticket-digest',
    platformPolicies: '/settings/platform-policies',
  },
  boomBarrierLogs: '/boom-barrier-logs',
  notifications: {
    base: '/notifications',
    unreadCount: '/notifications/unread-count',
    read: (id) => `/notifications/${encodeURIComponent(id)}/read`,
    markAllRead: '/notifications/mark-all-read',
  },
  operationBlocks: {
    appConfig: '/app-config',
    base: '/operation-blocks',
    active: '/operation-blocks/active',
    detail: (id) => `/operation-blocks/${encodeURIComponent(id)}`,
    schedule: (id) => `/operation-blocks/${encodeURIComponent(id)}/schedule`,
    activate: (id) => `/operation-blocks/${encodeURIComponent(id)}/activate`,
    end: (id) => `/operation-blocks/${encodeURIComponent(id)}/end`,
    cancel: (id) => `/operation-blocks/${encodeURIComponent(id)}/cancel`,
  },
  appVersionPolicies: {
    base: '/app-version-policies',
    detail: (id) => `/app-version-policies/${encodeURIComponent(id)}`,
    activate: (id) => `/app-version-policies/${encodeURIComponent(id)}/activate`,
    deactivate: (id) => `/app-version-policies/${encodeURIComponent(id)}/deactivate`,
  },
  onboarding: {
    workflows: '/onboarding/workflows',
    workflow: (id) => `/onboarding/workflows/${encodeURIComponent(id)}`,
    portfolio: '/onboarding/portfolio',
  },
  anomalies: {
    base: '/anomalies',
    summary: '/anomalies/summary',
    review: '/anomalies/review',
  },
  technicianTasks: {
    base: '/technician-tasks',
    detail: (id) => `/technician-tasks/${encodeURIComponent(id)}`,
  },
  users: {
    base: '/users',
    export: '/users/export',
    detail: (id) => `/users/${encodeURIComponent(id)}`,
    status: (id) => `/users/${encodeURIComponent(id)}/status`,
    sendCreateOtp: '/users/send-create-otp',
    emailVerification: (id) => `/users/${encodeURIComponent(id)}/email-verification/send`,
    bulkImport: '/users/bulk-import',
  },
  thirdParty: {
    vehicles: '/third-party/vehicles',
    vehicle: (id) => `/third-party/vehicles/${encodeURIComponent(id)}`,
    vehicleStatus: (id) => `/third-party/vehicles/${encodeURIComponent(id)}/status`,
    vehicleBulkImport: '/third-party/vehicles/bulk-import',
    logs: '/third-party/logs',
    logStats: '/third-party/logs/stats',
  },
  vehicles: {
    base: '/vehicles',
    export: '/vehicles/export',
    detail: (id) => `/vehicles/${encodeURIComponent(id)}`,
    status: (id) => `/vehicles/${encodeURIComponent(id)}/status`,
    access: (id) => `/vehicles/${encodeURIComponent(id)}/access`,
    requirements: '/vehicles/requirements',
    registrationCertificate: (id) => `/vehicles/${encodeURIComponent(id)}/registration-certificate`,
    mapExistingOtp: '/vehicles/map-existing/send-otp',
    mapExisting: '/vehicles/map-existing',
  },
  support: {
    tickets: '/support/tickets',
    ticket: (id) => `/support/tickets/${encodeURIComponent(id)}`,
    reply: (id) => `/support/tickets/${encodeURIComponent(id)}/reply`,
    status: (id) => `/support/tickets/${encodeURIComponent(id)}/status`,
    resolve: (id) => `/support/tickets/${encodeURIComponent(id)}/resolve`,
    close: (id) => `/support/tickets/${encodeURIComponent(id)}/close`,
  },
  contactInquiries: {
    base: '/contact-inquiries',
    detail: (id) => `/contact-inquiries/${encodeURIComponent(id)}`,
  },
  referrals: {
    base: '/referrals',
    detail: (id) => `/referrals/${encodeURIComponent(id)}`,
  },
  logs: {
    base: '/logs',
    export: '/logs/export',
    mobileSummary: '/logs/mobile-summary',
  },
  anprVisitorLogs: {
    base: '/anpr-visitor-logs',
    export: '/anpr-visitor-logs/export',
  },
  anprAccuracy: {
    export: '/anpr/accuracy/export',
    failures: '/anpr/accuracy/failures',
    mismatches: '/anpr/accuracy/mismatches',
    summary: '/anpr/accuracy/summary',
  },
  auditLogs: {
    base: '/audit-logs',
    detail: (id) => `/audit-logs/${encodeURIComponent(id)}`,
  },
  controllers: {
    nativeSsm: (id) => `/controllers/${encodeURIComponent(id)}/maintenance/ssm`,
    base: '/controllers',
    detail: (id) => `/controllers/${encodeURIComponent(id)}`,
    configs: (id) => `/controllers/${encodeURIComponent(id)}/configs`,
    incidents: (id) => `/controllers/${encodeURIComponent(id)}/incidents`,
    command: (id) => `/controllers/${encodeURIComponent(id)}/commands`,
    commandApproval: (id) => `/controllers/${encodeURIComponent(id)}/command-approvals`,
    nextDeviceId: '/controllers/next-device-id',
    healthSummary: '/controllers/health-summary',
    claimToken: (id) => `/controllers/${encodeURIComponent(id)}/claim-token`,
    lifecycle: (id) => `/controllers/${encodeURIComponent(id)}/lifecycle`,
  },
  adminApprovals: {
    approve: (id) => `/admin-approvals/${encodeURIComponent(id)}/approve`,
    controllerCommand: (id) => `/admin-approvals/controller-commands/records/${encodeURIComponent(id)}`,
    pendingControllerCommands: '/admin-approvals/controller-commands/pending',
  },
  accessPolicy: {
    goLiveReadiness: (societyId) =>
      `/access-policy/societies/${encodeURIComponent(societyId)}/go-live-readiness`,
    operationalState: (societyId) =>
      `/access-policy/societies/${encodeURIComponent(societyId)}/operational-state`,
    laneAccessPolicy: (laneId) => `/access-policy/lanes/${encodeURIComponent(laneId)}/access-policy`,
  },
  topology: {
    gates: (societyId) => `/topology/societies/${encodeURIComponent(societyId)}/gates`,
    createGate: '/topology/gates',
    lanes: (societyId) => `/topology/societies/${encodeURIComponent(societyId)}/lanes`,
    createLane: '/topology/lanes',
    mapLaneController: (laneId) => `/topology/lanes/${encodeURIComponent(laneId)}/controller`,
    mapLaneReader: (laneId) => `/topology/lanes/${encodeURIComponent(laneId)}/reader`,
    cameras: (societyId) => `/topology/societies/${encodeURIComponent(societyId)}/cameras`,
    createCamera: '/topology/cameras',
  },
  guard: {
    vehicleLookup: '/guard/vehicle-lookup',
    visits: '/guard/visits',
    activeVisits: '/guard/visits/active',
    visit: (id) => `/guard/visits/${encodeURIComponent(id)}`,
    cancelVisit: (id) => `/guard/visits/${encodeURIComponent(id)}/cancel`,
  },
  mobileVisits: {
    approve: (id) => `/mobile/visits/${encodeURIComponent(id)}/approve`,
    decline: (id) => `/mobile/visits/${encodeURIComponent(id)}/decline`,
  },
  commonData: {
    base: '/common-data',
    detail: (key) => `/common-data/${encodeURIComponent(key)}`,
  },
  rfid: {
    tags: '/rfid-tags',
    detail: (id) => `/rfid-tags/${encodeURIComponent(id)}`,
    stats: '/rfid-tags/stats',
    available: '/rfid-tags/available',
    import: '/rfid-tags/import',
    importPreview: '/rfid-tags/import-preview',
    importCommit: '/rfid-tags/import-commit',
    bulkCreate: '/rfid-tags/bulk-create',
    packets: '/rfid-tags/packets',
    batches: '/rfid-tags/batches',
    batchLink: (batchId) => `/rfid-tags/batches/${encodeURIComponent(batchId)}/link`,
    allocatePreview: '/rfid-tags/allocate-preview',
    allocate: '/rfid-tags/allocate',
    assign: '/rfid-tags/assign',
    reassign: '/rfid-tags/reassign',
    replace: '/rfid-tags/replace',
    unassign: (tagId) => `/rfid-tags/${encodeURIComponent(tagId)}/unassign`,
    status: (tagId) => `/rfid-tags/${encodeURIComponent(tagId)}/status`,
  },
};

export default API_ROUTES;
